import React from "react";
import {PresetSubGroupProps} from "../../../types/PresetProps";

interface SubGroupSectionProps {
    subGroups: PresetSubGroupProps[];
    onSelect: (subGroupId: number) => () => void;
    selectedSubGroup: PresetSubGroupProps | null;
}

const SUB_GROUP_DESCRIPTIONS = [
    'A single reminder, but you risk not being noticed.',
    'A second chance to re-engage without being too pushy.',
    'Balanced persistence to boost recovery while staying polite.',
    'Increased visibility, but it starts to feel more insistent.',
    'Maximum effort, but risks annoying the customer if overdone.'
]

const SubGroupSection = ({ subGroups, onSelect, selectedSubGroup }: SubGroupSectionProps) => {
    return (
        <div className="section">
            <div className="sub-title">How many messages would you like to send for each abandoned cart?</div>
            <div className="sub-group-options">
                {subGroups.map((subGroup, index) =>
                    <div key={`sub-group-${subGroup.id}-${index}`} className={`sub-group-option ${selectedSubGroup?.id === subGroup.id ? 'selected' : ''}`} onClick={onSelect(subGroup.id)}>
                        <div className="option-title"><div className="option-title-label">{subGroup.totalMessages} Message{subGroup.totalMessages > 1 ? 's' : ''}</div></div>
                        <div className="option-description">{SUB_GROUP_DESCRIPTIONS[index]}</div>
                    </div>
                )}
            </div>
            {/*<SubGroupSelection selectedGroup={presetGroups?.find(group => group.id === selectedGroupId)!} onSelectSubGroup={onSelectSubGroup} subGroups={presetSubGroups} onBackClick={() => setSelectedGroupId(null)} />*/}
        </div>
    )
}

export default SubGroupSection;